import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-15/task-01";

const task: Slide = {
  title: "Identify the dominant low frequency radiation type for the following different acoustic sources.",
  description: "Drag and drop pictures.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
